export default [
  { name: 'Básico PF', value: 'basic_pf' },
  { name: 'Intermediário PF', value: 'intermediary_pf' },
  { name: 'Completo PF', value: 'complete_pf' },
  { name: 'Localiza PF', value: 'locate_pf' },
  { name: 'Básico PJ', value: 'basic_pj' },
  { name: 'Intermediário PJ', value: 'intermediary_pj' },
  { name: 'Completo PJ', value: 'complete_pj' }
]
